module.exports = __webpack_public_path__ + "img/4-4.5f68c692.jpg";